import React, {Component} from 'react'
import {Helmet} from "react-helmet";

// COMPONENT ##########################################################

class HTMLDocumentHeadCustomizer extends Component {

    render () {

        // prepare default and prefix for custom
        const defaultTitle = "Gistify | Visualize What's Important";
        const {title} = this.props;
        const customTitle = "Gistify | " + title;


        return (
            <>
                <Helmet>

                    {/* title */}
                    { title && <title>{customTitle}</title>}
                    { !title && <title>{defaultTitle}</title>}

                </Helmet>
            </>
        )
    }
}

export default HTMLDocumentHeadCustomizer